import chatNotification from './chat-notification'
export default {
	items: [chatNotification]
} 
